<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title>
        <h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-application-outline</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.iframe') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5>
      </v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <v-slider
        style="padding-top: 20px"
        v-model="content.IframeHeight"
        :color="enterpriseColor"
        :label="$t('common.height')"
        min="0"
        max="1000"
        thumb-label
        @input="handleChangeIsModified"
      />
    </v-toolbar>
    <div
      v-show="!collapseContent"
      style="padding: 0 10px 10px 10px;"
    >
      
      <v-text-field
        v-model="content.IframeURL"
        append-icon="mdi-search"
        :label="$t('common.url')"
        hideDetails
        @input="handleChangeIsModified"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  export default {
    components: {
      Translate
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

